import type { ParsedFit } from 'fit-file-parser';

type TimerSummary = { total_timer_time?: number };

/** Reads active device time without substituting elapsed time or counting summaries twice. */
export function fitTimerDuration(parsed: Pick<ParsedFit, 'sessions' | 'laps'> & { activity?: TimerSummary }): number | undefined {
  return completeTimerTotal(parsed.sessions)
    ?? validTimer(parsed.activity?.total_timer_time)
    ?? completeTimerTotal(parsed.laps);
}

function completeTimerTotal(summaries: readonly TimerSummary[] | undefined): number | undefined {
  if (!summaries?.length) return undefined;
  let total = 0;
  for (const summary of summaries) {
    const seconds = validTimer(summary.total_timer_time);
    if (seconds === undefined) return undefined;
    total += seconds;
  }
  return Number.isFinite(total) ? total : undefined;
}

function validTimer(value: number | undefined): number | undefined {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : undefined;
}
